import { noClockSports } from 'sportsbook-essential-scores';

export const showClock = (clock, sportId) => !noClockSports.includes(sportId)
  && !(clock === '00:00');
